/**
 * User role domain shared by both apps.
 *
 * Original locations: (identical role names, verified):
 *  - web: apps/web/src/types/myAccount.ts (UserRolesTypes, ASSIGNABLE_ROLES, SUPER_ADMIN_ONLY_ROLES)
 *  - api: apps/api/src/user-management/constants.ts (role name constants, ASSIGNABLE_ROLES)
 *
 * The lists are typed as readonly string[] rather than `as const` tuples so callers can
 * test membership of a plain string (the api reads role names off Auth0 as string) without
 * a cast. Display labels stay web-local since the api has no use for UI copy.
 */
export const SUPERADMIN = 'superadmin';
export const ADMINISTRATOR = 'administrator';
export const TENANT_MANAGER = 'tenant_manager';
export const TENANT_ADMIN = 'tenant_admin';
export const USER = 'user';
export const CUSTOM_PROFILER = 'custom_profiler';
export const INSPECTION_CLONER = 'inspection_cloner';
export const USER_AUDIT_TRAIL = 'user_audit_trail';
/** Roles an administrator can assign to a team member as their primary role. */
export const ADMIN_ASSIGNABLE_ROLES = [ADMINISTRATOR, USER];
/** Assignable roles reserved for super admins. */
export const SUPER_ADMIN_ONLY_ROLES = [TENANT_MANAGER];
/**
 * Add-on an administrator can grant when User is the primary role. The add-on itself is
 * never offered as a radio choice or selected as the primary role on read.
 */
export const ADMIN_ASSIGNABLE_ADDON_ROLES = [USER_AUDIT_TRAIL];
/**
 * Every role that can be assigned as a primary role, regardless of who is assigning it.
 * Roles outside this list (tenant_admin, custom_profiler, inspection_cloner,
 * user_audit_trail) are add-on capabilities rather than a primary role, so they are
 * never offered as a choice.
 */
export const ALL_ASSIGNABLE_ROLES = [...ADMIN_ASSIGNABLE_ROLES, ...SUPER_ADMIN_ONLY_ROLES];
//# sourceMappingURL=user-role.js.map